import { useContext } from 'react';
import { Alert, AlertTitle } from '@mui/material';
import { UnderwritingSubmissionStateContext } from '../underwriting.submission.context';
import { useAsCase } from '../../../presentation';

export const UnderwritingSubmissionDetailOverviewStatusAlert = () => {
  const context = useContext(UnderwritingSubmissionStateContext);

  // Make 'status' and 'substatus' sentance case format
  const statusAsSentenceCase = useAsCase({
    value: context?.submission.status,
    casing: 'sentence',
  });

  const subStatusAsSentenceCase = useAsCase({
    value: context?.submission.subStatus,
    casing: 'sentence',
  });

  return (
    <>
      {statusAsSentenceCase === 'Lost' ||
      statusAsSentenceCase === 'Declined' ? (
        <div className="banner">
          <Alert severity="error" data-testid="alert-banner">
            <AlertTitle>{statusAsSentenceCase}</AlertTitle>
            {subStatusAsSentenceCase}
          </Alert>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};
